var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounComputerLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4697_36829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.667 3.14648C39.5217 3.14648 41.0303 4.65505 41.0303 6.50977V26.8203C41.0301 28.6749 39.5216 30.1826 37.667 30.1826H24.5459L25.3232 34.749H28.2793C28.8066 34.749 29.2324 35.1767 29.2324 35.7031V37.8984C29.2324 38.4248 28.8065 38.8516 28.2793 38.8516H13.7217C13.1947 38.8515 12.7676 38.4249 12.7676 37.8984V35.7031C12.7676 35.1766 13.1946 34.7491 13.7217 34.749H16.6768L17.4531 30.1826H4.33398C2.47936 30.1826 0.970862 28.6749 0.970703 26.8203V6.50977C0.970703 4.65505 2.47927 3.14648 4.33398 3.14648H37.667ZM14.6748 36.9453H27.3262V36.6562H14.6748V36.9453ZM18.6113 34.749H23.3906L22.6143 30.1826H19.3877L18.6113 34.749ZM2.87793 26.8203C2.87809 27.6233 3.53099 28.2764 4.33398 28.2764H37.667C38.47 28.2764 39.1239 27.6233 39.124 26.8203V26.1758H2.87793V26.8203ZM4.33398 5.05371C3.53093 5.05371 2.87793 5.70731 2.87793 6.50977V24.2695H39.124V6.50977C39.124 5.70731 38.47 5.05371 37.667 5.05371H4.33398Z",
    fill: "#1A1B23",
    stroke: "#1A1B23",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4697_36829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounComputerLight);
export default __webpack_public_path__ + "static/media/noun-computer-light.8b3d0d52c6bed43d28212504c6b893c6.svg";
export { ForwardRef as ReactComponent };